<div class="flex flex-col items-center space-y-4 mb-4">
    <h1 class="text-center !text-3xl !font-normal text-tertiary-900 !m-0">
        Thank you for using EWA!
    </h1>

    <h2 class="text-center !text-base !font-medium text-tertiary-900">
        This application has been submitted. Please check your email for a
        summary. For any changes, please contact EWA.
    </h2>
</div>

<div class="flex flex-col space-y-4">
    <app-go-application-purpose-selection
        [applicationId]="applicationState?.salmonLogId!"
        [orderId]="applicationState?.orderId?.toString()!"
    ></app-go-application-purpose-selection>

    <button
        class="!rounded-full w-full"
        type="button"
        color="primary"
        mat-raised-button
        (click)="backToPurposeOfFiling()"
        title="Close, or start a new application"
    >
        Close, or start a new application
    </button>
</div>

<div class="flex flex-col items-center space-y-4 mt-8">
    @if (user?.isMember) {
        <h1 class="text-center !text-2xl !font-normal text-tertiary-900 !m-0">
            Thanks {{ userOrganizationName }}, for being an EWA member!
        </h1>

        <img
            class="max-w-[200px] m-5"
            src="assets/images/EWA_Logo.jpg"
            alt="EWA Logo"
        />
    }

    @if (!user?.isMember) {
        <h1 class="text-center !text-2xl !font-normal text-tertiary-900 !m-0">
            Membership has its benefits!
        </h1>

        <a
            mat-button
            mat-raised-button
            color="primary"
            [href]="externalLinks.membership"
            target="_blank"
            rel="noopener"
            >Join EWA</a
        >

        <img
            class="max-w-[200px] m-5"
            src="assets/images/EWA_Logo.jpg"
            alt="EWA Logo"
        />
    }
</div>
